import StatisticDashboardContainer from './StatisticDashboardContainer';
export default StatisticDashboardContainer;
